// extracted by mini-css-extract-plugin
module.exports = {"navIcon":"NavIcon_navIcon__CaMtP"};